/* eslint-disable no-undef */
let animationFinished = true
let policyShowing = false

$(function () {
  const cookiesLink = $('#cookie-policy-link')
  const cookiePolicyContainer = $('#cookie-policy-container')
  if ($(cookiePolicyContainer).length > 0) {
    const cookieNotice = $('#cookie-notice')
    // add cookie policy after link
    $('#cn-notice-buttons').after(cookiePolicyContainer)

    // show/hide cookie policy on link click
    $(cookiesLink).on('click', function (event) {
      event.preventDefault()
      cookiesLinkClicked(cookieNotice, cookiePolicyContainer)
    })
  }
})

function cookiesLinkClicked (cookieNotice, cookiePolicyContainer) {
  if (!animationFinished) {
    // stop if already clicked and animation hasn't finished
    return
  }

  animationFinished = false

  if (!policyShowing) {
    // opening policy
    $(cookieNotice).toggleClass('show-cookie-policy')
  }
  $(cookiePolicyContainer).slideToggle(500, 'swing', function () {
    if (policyShowing) {
      // closing policy
      $(cookieNotice).toggleClass('show-cookie-policy')
      policyShowing = false
      animationFinished = true
    } else {
      // opening policy
      policyShowing = true
      animationFinished = true
    }
  })
}
